export default __webpack_public_path__ + "static/media/dc_negativo.85d59eb6.png";